import React from "react";

import { SubSection } from "../../../components/data-components/sections/DataSections";
import ImageUpload from "../../../components/image-upload/ImageUpload";
import {
  DamageMainCodeResponse,
  DamageC1CodeResponse,
  DamageC2CodeResponse,
} from "../../../api-models/response/DamageMainCodeResponse";
import { ImageUploadState } from "../../../components/image-upload/ImageUploadModel";
import { FieldsFromBM } from "../../../api-models/response/BluemetricFields";

interface AddDamageImageProps {
  uploadImageState: ImageUploadState;
  initialImageUri?: string;
}

export function AddDamageImage(props: AddDamageImageProps) {
  return (
    <SubSection className="image">
      <ImageUpload
        imageUploadState={props.uploadImageState}
        initialImageUri={props.initialImageUri}
        className="damage"
      />
    </SubSection>
  );
}

interface EditDamageImageProps {
  initialImageUri?: string;
  image: ImageUploadState;
}

export function EditDamageImage(props: EditDamageImageProps) {
  return (
    <SubSection className="image">
      <ImageUpload
        imageUploadState={props.image}
        initialImageUri={props.initialImageUri}
        className="damage"
      />
    </SubSection>
  );
}

export interface DamageFormValues {
  dynamicProperties: FieldsFromBM;
  groupCode: string;
  mainCode: DamageMainCodeResponse;
  c1Code: DamageC1CodeResponse;
  c2Code: DamageC2CodeResponse;
}
